import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import ChartDataLabels from "chartjs-plugin-datalabels";

ChartJS.register(CategoryScale, LinearScale, BarElement, Title);

const BarChart = ({ chartData, barLabel, barColor }) => {
  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "top",
      },
      datalabels: {
        anchor: "end",
        align: "end",
        borderRadius: 5,
        color: '#fff',
        font: {
          weight: 'bold'
        },
        backgroundColor: function(context) {
          return context.dataset.backgroundColor;
        },
        padding: 5,
      },
    },
    scales: {
      x: {
        grid: {
          display: false,
        },
        ticks: {
          color: "#3F3D56",
          font: {
            size: 14,
            family: "Poppins",
            weight: 500,
          },
        },
      },
      y: {
        min: 0,
        grace: "5%",
        max:3.5,
        // define the y scale ticks

        ticks: {
          color: "#000",
          font: {
            size: 14,
            family: "Poppins",
            weight: 600,
          },
        },
        grid: {
          // display: false,
          // style the y scale grid lines
          // drawBorder: false,
        },
      },
    },
  };

  const labels = barLabel;

  const data = {
    labels,
    datasets: [
      {
        label: "Dataset 1",
        data: chartData,
        backgroundColor: barColor,
        barPercentage: 0.5,
        barThickness: 60,
      },
    ],
  };

  return (
    <Bar
      className="w-full pl-5 pr-5"
      options={options}
      data={data}
      plugins={[ChartDataLabels]}
    />
  );
};

export default BarChart;
